import React from 'react';
import { Card } from 'antd';
import DecisionsTable from './DecisionsTable';
import { useQuery } from 'react-query';
import { getDecisionListByCtrid } from '../../../services/proposal';
import { isNil } from 'lodash';
import GetLabel from 'DisplayFramework/components/GetLabel';

type DecisionsProps = {
  ctrid?: number;
  onOpenDecisionDetail?: (id: number) => void;
  refetchProp: any;
  isActive?: boolean;
};

const Decisions = (props: DecisionsProps) => {
  const { ctrid, onOpenDecisionDetail,refetchProp,isActive } = props;

  const { data: decisions } = useQuery(
    ['getDecisionListByCtrid', { ctrid,refetchProp }],
    () =>
      getDecisionListByCtrid({ ctrid: ctrid! }).then((res) => res.list || []),
    { enabled: !isNil(ctrid) && isActive !== false }
  );

  return (
    <Card
    title={
      <GetLabel
        label="Decision"
        style={{ fontWeight: 'bold', paddingLeft: 15 }}
      />
    }
      style={{
        width: '100%',
        boxShadow:
          'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
      }}
      bordered
      className="p-13"
    >
      <DecisionsTable
        decisions={decisions}
        onOpenDecisionDetail={onOpenDecisionDetail}
      />
    </Card>
  );
};

export default Decisions;
